import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Powerbitemplate extends Component {
 
  render() {
    const course =[
      {    title: "Introduction to Power BI",    content: [      "Overview of Power BI",      "Understanding the Power BI ecosystem",      "Power BI architecture",      "Power BI features and benefits"    ]
  },
  {
    title: "Connecting to Data Sources",
    content: [
      "Connecting to different data sources",
      "Importing data into Power BI",
      "Transforming data in Power Query Editor",
      "Creating relationships between tables"
    ]
  },
  {
    title: "Creating Reports and Visualizations",
    content: [
      "Overview of report design",
      "Creating visualizations with charts, tables, and matrices",
      "Using custom visuals",
      "Creating interactive reports with drill-through and drill-down",
      "Formatting and customizing visualizations"
    ]
  },
  {
    title: "Working with DAX Formulas",
    content: [
      "Introduction to DAX formulas",
      "Working with calculated columns and measures",
      "Aggregation and filtering with DAX",
      "Time intelligence calculations"
    ]
  },
  {
    title: "Advanced Data Modeling",
    content: [
      "Creating complex data models",
      "Working with multiple fact tables",
      "Using bidirectional relationships",
      "Solving common data modeling problems"
    ]
  },
  {
    title: "Advanced Visualizations",
    content: [
      "Creating hierarchical visualizations",
      "Using advanced visuals like gauges and cards",
      "Creating custom themes",
      "Creating mobile reports",
      "Creating paginated reports"
    ]
  },
  {
    title: "Collaborating and Sharing",
    content: [
      "Publishing reports to the Power BI service",
      "Creating and managing dashboards",
      "Sharing and collaborating on reports and dashboards",
      "Using Power BI mobile apps"
    ]
  },
  {
    title: "Data Governance and Security",
    content: [
      "Creating and managing workspaces",
      "Configuring data refresh",
      "Using row-level security",
      "Applying data classification"
    ]
  },
  {
    title: "Advanced Analytics with Power BI",
    content: [
      "Using advanced analytics features",
      "Creating machine learning models with Power BI",
      "Working with R scripts",
      "Working with Python scripts"
    ]
  },
  {
    title: "Power BI with Excel",
    content: [
      "Using Power BI with Excel",
      "Creating reports with Excel and Power BI",
      "Working with PivotTables and PivotCharts",
      "Working with Power Pivot and Power Query"
    ]
  },
  {
    title: "Power BI API and Customization",
    content: [
      "Using the Power BI REST API",
      "Creating custom visuals with TypeScript and D3.js",
      "Integrating Power BI with other applications",
      "Creating custom connectors"
    ]
  },
  {
    title: "Power BI for Developers",
    content: [
      "Introduction to Power BI Embedded",
      "Creating and embedding Power BI reports",
      "Using the Power BI JavaScript API",
      "Creating custom visuals for Power BI"
    ]
  }
    ]

    const faqData = [
      {
        question: 'What makes a training centre the best choice for Power BI learning? ',
        answer:
          'The best training centre for Power BI offers comprehensive courses designed by industry experts, hands-on practical experience, flexible learning options, and personalized attention to ensure every learner grasps the concepts effectively.  ',
      },
      {
        question: `How do I know if I'm ready for Power BI training? `,
        answer:
          'Power BI training is suitable for anyone interested in data analysis, visualization, and reporting. Basic knowledge of data analysis concepts and familiarity with Excel can be beneficial but not mandatory.',
      },
      {
        question: 'What topics are covered in Power BI training?',
        answer:
          'Power BI training typically covers a range of topics including data modeling, visualization techniques, DAX calculations, Power Query, dashboard creation, and connecting to various data sources.'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Power BI skills can pursue a variety of career opportunities such as Data Analyst, Business Analyst, Business Intelligence Developer, and Data Scientist.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embarking on a journey to master Power BI involves understanding the prerequisites to ensure a seamless learning experience. At our esteemed learning institute, individuals aspiring to delve into Power BI should possess a foundational understanding of data analysis concepts and basic computer skills. Proficiency in Microsoft Excel can also be advantageous, although not mandatory. Our comprehensive Power BI training programs cater to diverse skill levels, from beginners to advanced users, offering tailored courses that empower learners to harness the full potential of this powerful data visualization tool. With experienced instructors, hands-on practical exercises, and cutting-edge curriculum, our institute stands out as the best training centre for honing your Power BI skills and advancing your career in data analytics and business intelligence."
      },

    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ansar",
          date:" Sep 14 ,2023",
          review:`learnsoft.org is a renowned training provider in ${this.props.location}, To truly understand the effectiveness of Power Bi training at learnsoft.org let's hear from the students themselves. Many have praised the institute's hands-on approach, experienced instructors, and real-world projects that enhance their learning experience. `
        
        },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Basith",
          date:" Oct 23 ,2023",
          review:`Earning a Power Bi certification from learnsoft.org comes with several benefits, Upon completing your Power Bi Training, learnsoft.org provides you with a recognized certification. This certification is a testament to your acquired skills and can open doors to numerous career opportunities. `
        
        },
  ]
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Power BI is a collection of software services, apps, and connectors that work together to turn your unrelated sources of data into coherent, visually immersive, and interactive insights. Your data may be an Excel spreadsheet, or a collection of cloud-based and on-premises hybrid data warehouses. Power BI lets you easily connect to your data sources, visualize and discover what&apos;s important, and share that with anyone or everyone you want."/>
          */}
            <NewMainsec rating='5' students={"439"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Power BI is a collection of software services, apps, and connectors that work together to turn your unrelated sources of data into coherent, visually immersive, and interactive insights. Your data may be an Excel spreadsheet, or a collection of cloud-based and on-premises hybrid data warehouses. Power BI lets you easily connect to your data sources, visualize and discover what&apos;s important, and share that with anyone or everyone you want."/>
          
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Power BI ${this.props.location1} is an in-demand field with a growing demand for professionals with Power BI skills. At Learnsoft.org, we offer top-notch Power BI training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Power BI principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Power BI or looking to expand your skillset, Learnsoft.org's Power BI ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Power BI journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Power BI course covers a wide range of topics, including data visualization, data analysis, and data reporting. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Power BI. By the end of the course, you will be able to implement Power BI practices in your own projects."}/>
        	</section>
 <Batchtime title={this.props.title} offer="24,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou1="Power Platform" coupath1="power-platform" cou='PowerApps' coupath='powerapps' cou2='Power Automate' coupath2='power-automate' cou3='Power Pages' coupath3='power-pages' cou4='Tableau' coupath4='tableau'
          cou5='Salesforce' coupath5='salesforce' cou6='Dynamics 365' coupath6='dynamic365' cou7='Robotic Process Automation' coupath7='rpa'
          cou9='R Programining' coupath9='rprogram' cou8='Azure Data Engineering' coupath8='azure-data-engineering'  cou10='Pega' coupath10='pega' />
      </>
    );
  }
}
